/**
 * Class to model an ApiResponse.
 * */
export default class ApiResponse {
    constructor(error, responseCode, data) {
        this.error = error;
        this.responseCode = responseCode;
        this.data = data;
    }
}